/**
 * Caches collection grid HTML + scroll position in sessionStorage so
 * browser back from a product page can restore Page A without reloading.
 */
(function () {
  const PREFIX = "collectionPageCache:";
  const MAX_AGE_MS = 30 * 60 * 1000;
  const MAX_BYTES = 4 * 1024 * 1024;

  function getFacetSearchString() {
    const params = new URLSearchParams(window.location.search);
    params.delete("pagination__more");
    params.delete("selectedProductId");
    return params.toString();
  }

  function getCacheKey() {
    const qs = getFacetSearchString();
    return `${window.location.pathname}${qs ? "?" + qs : ""}`;
  }

  function isBackNavigation() {
    const nav = performance.getEntriesByType("navigation")[0];
    return !!(nav && nav.type === "back_forward");
  }

  function isCollectionPage() {
    return !!document.getElementById("ProductGridContainer");
  }

  function save() {
    if (!isCollectionPage()) return;

    const grid = document.getElementById("ProductGridContainer");
    if (!grid) return;

    const payload = JSON.stringify({
      html: grid.innerHTML,
      scrollY: window.scrollY,
      timestamp: Date.now(),
    });

    if (payload.length > MAX_BYTES) return;

    try {
      sessionStorage.setItem(PREFIX + getCacheKey(), payload);
    } catch (e) {}
  }

  function restore() {
    if (!isCollectionPage() || !isBackNavigation()) return false;

    const raw = sessionStorage.getItem(PREFIX + getCacheKey());
    if (!raw) return false;

    try {
      const data = JSON.parse(raw);
      if (Date.now() - data.timestamp > MAX_AGE_MS) {
        sessionStorage.removeItem(PREFIX + getCacheKey());
        return false;
      }

      const grid = document.getElementById("ProductGridContainer");
      if (!grid || !data.html) return false;

      grid.innerHTML = data.html;

      requestAnimationFrame(function () {
        window.scrollTo(0, data.scrollY || 0);
        if (typeof window.scrollToSelectedProduct === "function") {
          window.scrollToSelectedProduct();
        }
      });

      if (typeof swymCallbackFn === "function") swymCallbackFn();

      return true;
    } catch (e) {
      return false;
    }
  }

  function clear(key) {
    sessionStorage.removeItem(PREFIX + (key || getCacheKey()));
  }

  window.CollectionPageCache = {
    save: save,
    restore: restore,
    clear: clear,
    getCacheKey: getCacheKey,
    isBackNavigation: isBackNavigation,
    isCollectionPage: isCollectionPage,
  };

  document.addEventListener(
    "DOMContentLoaded",
    function () {
      if (!isCollectionPage()) return;
      window.__collectionPageCacheRestored = restore();
    },
    true
  );

  window.addEventListener("pagehide", function () {
    if (isCollectionPage()) save();
  });
})();
